// extracted by mini-css-extract-plugin
export default {"apptsSearch":"ApptsSearch_apptsSearch__BKNTr","tabs":"ApptsSearch_tabs__XFolH","practiceSelect":"ApptsSearch_practiceSelect__1Ny8B"};